export const api = {
    GET_CARDS_LIST_API: "/api/cards/list",
    EDIT_CARD_API : "/api/cards/edit",
    ADD_CARD_API : "/api/cards/add",
    GET_CARD_API : "/api/cards/getCard",
    GET_CARD_BY_BARCODE_API : "/api/cards/getCardByBarcode",
    REMOVE_CARD_API : "/api/cards/removeCard"
}